import { Navigate } from "react-router-dom";
import RoutingProfile from "./pages/transaction-routing/routing-profile";
import { RoutingConfig } from "./pages/transaction-routing/routing-config";
import TransactionRoutingOutlet from "./pages/transaction-routing/transaction-routing-outlet";
// import PricingList from "./pages/pricings/Pricings";
// import PricingEditGuard from "@/guards/tech-pricing-edit-guard";
// import GlobalPricingEdit from "./pages/pricings/global-tech-pricing-edit";
// import PricingDetail from "./pages/pricings/tech-pricing-details";
// import { TransactionRouting } from "./pages/transactionRouting/TransactionRouting";

const TechRoutes = [
  {
    path: "/tech",
    children: [
      {
        path: "transaction-routing",
        element: <TransactionRoutingOutlet />,
        children: [
          {
            index: true,
            element: <Navigate to="profiles" replace />,
          },
          {
            path: "profiles",
            element: <RoutingProfile />,
          },
          {
            path: "config",
            element: <RoutingConfig />,
          },
        ],
      },
  //     { path: "pricings", element: <PricingList /> },
  // {
  //   path: "pricings/edit",
  //   element: (
  //     <PricingEditGuard>
  //       <GlobalPricingEdit />
  //     </PricingEditGuard>
  //   ),
  // },
  // { path: "pricings/:merchantId/:productName", element: <PricingDetail /> },
    ],
  },
];

export default TechRoutes;
